export default {
  API_ENDPOINT:  "https://pacific-lake-42207.herokuapp.com/api",
  TOKEN_KEY: 'blogful-client-auth-token',
}

/* 
"http://localhost:8080/api" ||
*/